import './assets/form-control-description.css';
import { jsx as n } from "react/jsx-runtime";
import i from "clsx";
const c = "_description_13ppf_1", e = {
  description: c
}, m = (r) => {
  const { children: o, className: s, ...t } = r;
  return o == null ? null : /* @__PURE__ */ n("span", { ...t, className: i(e.description, s), children: o });
};
export {
  m as FormControlDescription
};
